<template>
    <div class="item-price" :class="{ 'has-discount': hasDiscount }">
        <template v-if="hasDiscount">
            <div class="price-before-discount">
                <span class="discount-type">
                    <i v-if="isDiscountTypePercentage" class="fa-light fa-percent"></i>
                    <i v-if="isDiscountTypeAbsolute" class="fa-light fa-tag"></i>
                </span>
                {{ toMoney(totalItemPrice) }}
            </div>
            <div class="price-after-discount">
                {{ toMoney(totalItemPriceAfterDiscount) }}
            </div>
        </template>
        <template v-else>
            {{ toMoney(totalItemPrice) }}
        </template>
    </div>
</template>

<script setup lang="ts">
    import { DiscountType } from "@/data/model/Enums";
    import { toMoney } from "@/shared/utils/format";
    import { computed } from "vue";

    const props = defineProps<{
        hasDiscount: boolean;
        quantity: number;
        singlePrice: number;
        singlePriceAfterDiscount?: number;
        discountType?: DiscountType;
    }>();

    const isDiscountTypePercentage = computed(() => props.discountType === DiscountType.Percentage);
    const isDiscountTypeAbsolute = computed(() => props.discountType === DiscountType.Absolute);

    const totalItemPrice = computed(() => props.quantity * props.singlePrice);
    const totalItemPriceAfterDiscount = computed(
        () => props.quantity * (props.singlePriceAfterDiscount ?? props.singlePrice)
    );
</script>

<style scoped lang="scss">
    @use "./../../../assets/styles/scss/shared/_colors.scss";

    .item-price {
        text-align: right;
        white-space: nowrap;

        .discount-type {
            font-size: 0.8em;
            margin-right: 0.25em;

            > i {
                color: colors.$pink;
            }
        }

        .price-before-discount {
            color: colors.$pink;
            text-decoration: line-through;
        }

        .price-after-discount {
            color: colors.$fontColor;
        }
    }
</style>
